import { render } from "./AllEMRInsurances.vue?vue&type=template&id=25b6df9e"
import script from "./AllEMRInsurances.vue?vue&type=script&lang=js"
export * from "./AllEMRInsurances.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/emrInsurances/AllEMRInsurances.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25b6df9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25b6df9e', __exports__)) {
    console.log('reload')
    api.reload('25b6df9e', __exports__)
  }
  
  module.hot.accept("./AllEMRInsurances.vue?vue&type=template&id=25b6df9e", () => {
    console.log('re-render')
    api.rerender('25b6df9e', render)
  })

}


export default __exports__